import { delay, put, takeEvery } from 'redux-saga/effects';
import { addToaster, removeToaster } from '../slices/toast.slice';

function* handleAddToaster(action: ReturnType<typeof addToaster>) {
    const { id } = action.payload;

    yield delay(3000);
    yield put(removeToaster(id));
}

export function* watchAddToaster() {
    yield takeEvery(addToaster.type, handleAddToaster);
}
